import Vue from "vue"

export default (_, inject) => {
    inject("speed", Vue.observable({
        isSlow: null,
        downlink: 0,
        saveData: null,
    }))
}
